import { Navigate, Outlet, useLocation } from 'react-router';
import { Loader2 } from 'lucide-react';

import { useAuth } from '@/features/auth/contexto';
import type { PerfilUsuario } from '@/features/auth/tipos';

interface RotaProtegidaProps {
  /** Quando omitido, basta estar autenticado. */
  perfis?: PerfilUsuario[];
}

/**
 * Guarda de rota do lado do cliente.
 *
 * É conveniência de navegação, não segurança: quem autoriza de fato é o
 * backend, que revalida perfil em cada requisição. Esconder um item de menu
 * não protege o dado por trás dele.
 */
export function RotaProtegida({ perfis }: RotaProtegidaProps) {
  const { usuario, carregando } = useAuth();
  const local = useLocation();

  if (carregando) {
    return (
      <div className="flex min-h-dvh items-center justify-center" role="status">
        <Loader2 className="text-silenciado-texto size-6 animate-spin" aria-hidden="true" />
        <span className="apenas-leitor-tela">Verificando sessão…</span>
      </div>
    );
  }

  if (!usuario) {
    // Guarda o destino para retomar a navegação após o login.
    return <Navigate to="/login" state={{ de: local.pathname }} replace />;
  }

  // Enquanto a senha provisória não for trocada, o acesso fica restrito.
  if (usuario.precisaTrocarSenha && local.pathname !== '/trocar-senha') {
    return <Navigate to="/trocar-senha" replace />;
  }

  if (perfis && !perfis.includes(usuario.perfil)) {
    return <Navigate to="/sem-permissao" replace />;
  }

  return <Outlet />;
}
